import { useStylesHook } from "../hooks/useStylesHook";
import { calculateDimension } from "../styling/dimensions.styles";
export function useFlexStyles(props) {
    return useStylesHook({
        flex: {
            display: "flex",
            flexDirection: props?.direction ?? {},
            gap: calculateDimension(props?.gap),
            alignItems: props?.alignItems ?? {},
            justifyContent: props?.justifyContent ?? {},
            flexWrap: props?.wrap ? "wrap" : {},
        },
    });
}
